import gql from 'graphql-tag';

export default gql(`
	query hospitality_manager_events {
		hospitality_manager_events {
			guid
			name
			description
			date
			time
			image_url
			registration_url
		}
	}
`);

